import { createI18n } from 'vue-i18n';
import en from '@/lang/en.json';

// currently only english is supported
const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
  },
});

export default i18n;
